import { Icon } from "@/components/Icon/Icon";
import type { ChangeKind } from "./ChangeSymbol";

type UndoButtonProps = {
  kind: ChangeKind;
  onClick: () => void;
};

export function UndoButton({ kind, onClick }: UndoButtonProps) {
  const title =
    kind === "add"
      ? "Discard this addition"
      : kind === "remove"
      ? "Restore this substance"
      : "Reset to previous concentration";
  return (
    <button type="button" onClick={onClick} className="af-undo" title={title}>
      <Icon name="reset" size={11} />
      <span>Undo</span>
    </button>
  );
}
